import Box from '@components/base/Box'
import { RegistrationFieldInputOption } from '@graphql/__generated/graphql'
import React, { useEffect, useState } from 'react'
import { BiListPlus } from 'react-icons/bi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { BaseInputProps } from '../BaseInputProps'
import { Button } from '../Button'
import { validate } from '../Validations'

export interface OptionInputProps
  extends Pick<
    BaseInputProps,
    | 'onChange'
    | 'validations'
    | 'className'
    | 'placeholder'
    | 'testid'
    | 'value'
    | 'required'
    | 'show'
  > {
  name: string
}

export type OptionsData = RegistrationFieldInputOption[]

const defaultOptionsData: OptionsData = [{ label: '', value: '' }]

export default function OptionsInput({
  name,
  value,
  className,
  placeholder,
  testid,
  required = false,
  onChange,
  validations,
  show,
}: OptionInputProps) {
  const [optionsData, setOptionsData] = useState<OptionsData>(
    value ?? defaultOptionsData
  )

  useEffect(() => {
    changeHandler(optionsData)
  }, [optionsData])

  useEffect(() => {
    setOptionsData(value ?? defaultOptionsData)
  }, [value])

  const changeHandler = (opts: OptionsData) => {
    const isInvalid = validate(opts, validations) !== ''
    onChange && onChange(opts, isInvalid)
  }

  const input = (val: string, index: number) => (
    <input
      data-testid={testid ? `${testid}-${val}` : null}
      value={val}
      onChange={(e) => {
        setOptionsData((state) =>
          state.map((option, i) =>
            i === index
              ? { label: e.target.value, value: e.target.value }
              : option
          )
        )
      }}
      type="text"
      placeholder={placeholder}
      id={`${name}-${val.replaceAll(' ', '').toLowerCase()}`}
      className={`transition-all bg-transparent rounded px-4 py-4 text-sm outline-none placeholder-gray-500 flex-3`}
    />
  )
  if (!show) return <></>

  return (
    <>
      {optionsData?.map((option, index) => {
        return (
          <React.Fragment key={index}>
            <label
              className={[
                'flex flex-col my-1 rounded border justify-center',
                className,
              ].join(' ')}
            >
              <Box className="flex justify-between h-full">
                {input(option.value, index)}
                <Box className="flex justify-end flex-1 items-center pr-2">
                  <Button
                    type="square"
                    icon={<RiDeleteBinLine size={20} />}
                    className="mr-2 border-none"
                    onClick={() =>
                      setOptionsData((state) =>
                        state.filter((_, i) => i !== index)
                      )
                    }
                  />
                </Box>
              </Box>
            </label>
          </React.Fragment>
        )
      })}
      <Button
        type="square"
        icon={<BiListPlus size={32} />}
        className="self-start border-none !pl-3 mt-3"
        onClick={() =>
          setOptionsData((state) => [
            ...(state ?? []),
            { label: '', value: '' },
          ])
        }
      />
    </>
  )
}
